import axios from "axios";
import { getDistributorPartNumberProperty } from "../../property";
import { fetchDatasheetFromLcscProductPageUrl } from "../LCSC/fetchDatasheetFromLcscProductPageUrl";
export const getDatasheetViaDpn = async (properties, scraperAPILKey) => {
    // Making it easy to extend this with other distributors in the future
    return await getDatasheetFromLcsc(properties, scraperAPILKey);
};
async function getDatasheetFromLcsc(properties, scraperAPILKey) {
    const lcscDpn = getDistributorPartNumberProperty("lcsc", properties)?.value;
    if (lcscDpn && typeof lcscDpn === "string") {
        try {
            const response = await axios.get(`https://easyeda.com/api/products/${lcscDpn.trim()}/components?version=6.4.19.5`);
            const data = response?.data;
            if (data && data.success) {
                const productDetailPageUrl = data.result?.lcsc?.url;
                if (productDetailPageUrl) {
                    const datasheetUrl = await fetchDatasheetFromLcscProductPageUrl(productDetailPageUrl, scraperAPILKey);
                    return datasheetUrl || undefined;
                }
            }
        }
        catch {
            return undefined;
        }
    }
}
//# sourceMappingURL=GetDatasheetViaDpn.js.map